export default function callIfArgumentsPass(condition, callback) {
    let previousArgs = null;
    let cleanup;

    return function onCalled(...args) {
        let shouldCall = true;
        if (previousArgs != null) {
            shouldCall = condition.apply(null, previousArgs.concat(args));
        }
        previousArgs = args;
        if (shouldCall) {
            if (cleanup) {
                cleanup();
                cleanup = null;
            }
            cleanup = callback.apply(null, args);
        }
    };
}
